import React from 'react';
import styles from './store-links.module.scss';

const StoreLink = ({ to, className, store }) => {
  return (
    <a href={to} className={`${styles.wrapper} ${className ? className : ''} ${styles[store]}`} target={'_blank'}></a>
  );
};

export default StoreLink;